import styled from "styled-components";

import { theme } from "../../themes/themes";
export const ContentModal = styled.div`
  position: absolute;
  left: 25%;
  bottom: 30%;
  width: 600px;
  height: fit-content;
  max-width: 70%;
  background: ${({ theme }) => theme.primaryBackgroundLight};
  border: 1px solid ${({ theme }) => theme.neutral.gray[700]};
  box-sizing: border-box;
  box-shadow: 2px 2px 25px ${({ theme }) => theme.shadows.strong};
  border-radius: 4px;
  overflow: auto;
  @media only screen and (min-width: 769px) {
    left: 25%;
  }
  @media only screen and (min-width: 491px) and (max-width: 768px) {
    left: 15%;
  }
  @media only screen and (max-width: 480px) {
    left: 15%;
  }
`;

export const ButtonApproval = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 36px;
  left: 732px;
  top: 336px;
  background: ${({ theme }) => theme.button.primary};
  border-radius: 4px;
  border: none;
  margin: 1em auto;
  color: white;
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.neutral.gray[200]};
    text-decoration: none;
    background-color: transparent;
  }
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
  }
`;
export const ButtonCancel = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 36px;
  left: 732px;
  top: 336px;
  background: white;
  border-radius: 4px;
  border: 1px solid;
  margin: 1em auto;
  color: ${({ theme }) => theme.button.primary};
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.neutral.gray[200]};
    text-decoration: none;
    background-color: transparent;
  }
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
  }
`;

export const CloseModal = styled.div`
  height: 3.5em;
  width: 100%;
  text-align: end;
  padding: 0.5em;
  font-weight: 600;
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.neutral.black};
    text-decoration: none;
    background-color: transparent;
  }
`;

export const TextModal = styled.div`
  padding: 1em;
  border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
  text-align: center;
  height: 15em;
  width: 100%;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 0.3em;
  }
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.neutral.gray[1000]};
    border-radius: 3px;
    border: 1px solid #c7b9c475;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #fdfdfd73;
    border-radius: 10px;
  }
`;

export const ContentDescription = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #ededed;
  border-radius: 3px;
`;

export const TitleApproval = styled.p`
  font-size: 18px;
  text-align: center;
  font-family: ${({ theme }) => theme.secondaryFontFamilyTwo};
`;

export const DescriptionApproval = styled.p`
  color: ${({ theme }) => theme.neutral.black};
  font-size: 14px;
  text-align: center;
  font-family: ${({ theme }) => theme.secondaryFontFamilyTwo};
`;
